import { AvatarResponseDto } from '@vp/profile/data/dto/AvatarResponseDto';
import { ImageResponseDto } from '@vp/profile/data/dto/ImageResponseDto';
import { TimelineResponseDto } from '@vp/profile/data/dto/TimelineResponseDto';
import { TributeResponseDto } from '@vp/profile/data/dto/TributeResponseDto';
import { VideoResponseDto } from '@vp/profile/data/dto/VideoResponseDto';

import { LiveMediaResponseDto } from './LiveMediaResponseDto';

export enum RestrictedSection {
  Bio = 'bio',
  Tributes = 'tributes',
  Timeline = 'timeline',
  Gallery = 'gallery',
}

export interface ProfileResponseDto {
  active: boolean;
  id: string;
  name: string;
  date_of_birth?: string;
  date_of_death?: string;
  bio?: string;
  voiced_bio?: string | null;
  avatar?: AvatarResponseDto | null;
  images?: ImageResponseDto[];
  videos?: VideoResponseDto[];
  restricted_sections?: RestrictedSection[];
  fully_restricted?: boolean;
  settings?: {
    selected_background_images: [];
    allow_upload_by_link: boolean;
    tributes_enabled: boolean;
    allow_anonymous_tributes: boolean;
    intro_video_enabled: boolean;
    background_mode: string;
    color: string | null;
    show_all_attached_images: boolean;
    slideshow_melody: string;
    restricted_access_pin: string;
    restricted_sections: RestrictedSection[];
    fully_restricted?: boolean;
  };
  tributes?: TributeResponseDto[];
  timelines?: TimelineResponseDto[];
  premium?: boolean;
  live_media?: LiveMediaResponseDto;
}
